export default __webpack_public_path__ + "static/media/edit-active.ba667044.svg";